import { GatsbyImage } from "gatsby-plugin-image"
import * as React from "react"
import TextSpacer from "./textSpacer"
import useAnimateInView from "../lib/useAnimateInView"
import Spacer from "./spacer"

const SplitSection = ({ splitSection }) => {
	const { splitSectionParagraph, splitSectionImage, splitSectionSubtitle, splitSectionImageCaption } = splitSection
	const text = useAnimateInView()
	const image = useAnimateInView()
	return (
		<div className='p40' id='lifestyle'>
			<div className='max-1200 ma flex i-flex-col m-flex-col'>
				<div className='w-50 pr40 flex inview  ' ref={text}>
					<div className='   '>
						<p className='h3 m0 m-mb40 mb20'>LIFESTYLE</p>
						<Spacer />
						<h5 className='max-200'>{splitSectionSubtitle}</h5>
						<TextSpacer />
						<div className='pb40 max-400 m-mb40 op65'>{splitSectionParagraph}</div>
					</div>
				</div>
				<div className='w-50 pr40  i-w-100' ref={image}>
					<Spacer className='i-show' />
					<div className='ratio-1-1 bg-grey'>
						<div className='bg-image'>
							<GatsbyImage className='bg-image' image={splitSectionImage.gatsbyImageData} alt={splitSectionImage.alt || splitSectionImageCaption || 'Property Image'} />
						</div>
					</div>
					<p className='image-caption mt10'>{splitSectionImageCaption}</p>
				</div>
			</div>
		</div>
	)
}

export default SplitSection
